import React from "react";
import "./StoresFooter.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import empty_box2 from "../images/empty_box2.svg"
import {
    store,
    show_store,
    filter_data,
    sort_data,
  } from "../Redux/API";
  import { useEffect } from "react";
  import { useSelector } from "react-redux";
  import { showRegister } from "../Redux/HomeSlice";
import Register from "../Register/Register";
import Loader from "../Loader";
import { useNavigate } from "react-router-dom";
import Searsh from "../Searsh/Searsh";

const Contact = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
      dispatch(store());
    }, [dispatch]);

    const Stores = useSelector((state) => state.Data.store);
    const loadingStore = useSelector((state) => state.Data.loadingStore);

      const gotoStore = (id) => {
        localStorage.setItem("storeId", id);
        dispatch(filter_data({influencer_id: null, brand_id: null, store_id: id}));
        dispatch(sort_data({influencer_id: null, brand_id: null, store_id: id}));
        navigate("/Store");
        dispatch(show_store({ id }));
        window.scrollTo(0, 0);
      };





      const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    
      const getLocalStorage = window.localStorage.getItem("UserInfo");
      const valueLocalStorage = getLocalStorage
        ? JSON.parse(getLocalStorage)
        : null;
      const token =
        valueLocalStorage?.data?.token ||
        valueLocalStorage?.data?.data?.user?.token ||
        null;
    
      const showR = useSelector((state) => state?.products?.showR);
    
      const Sign_Up = (event) => {
        if (!token) {
          const { pageY } = event;
          const offsetY = -1200;
          setPopupPosition({ x: 50, y: pageY + offsetY });
          dispatch(showRegister(true));
        }
      };

      const images = Stores?.data?.data || [];
    
      const show_searsh = useSelector((state) => state?.products?.searsh);

      return (
        <div className="About">
        <Header />
        {showR && (
        <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}

            {show_searsh && (
              <Searsh />

            )}
             <div className="stores-container">
             <h3 className="stores-title">{t('stores')}</h3>
             {images.length == 0 && (
            <div className="empty-cart">
              <img src={empty_box2} alt="Empty Cart" />
            </div>

          )}
             <div className="stores-grid">
         {Stores?.data?.data.map((store) => (
          <div key={store.id} className="store-card" onClick={() => gotoStore(store.id)}>
            <img src={store.image} alt={store.name} className="store-image" />
            <h2 className="store-name">{store.name}</h2>
            <p className="store-address">{store.address}</p>
          </div>
        ))}
      </div>
    </div>
        <Footer Sign_Up={Sign_Up} />

        </div>
      );
    };
    
    export default Contact;